import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { api, errMsg } from "@/lib/api";

export const APPT_STATUS = {
  scheduled: ["Scheduled", "bg-sky-100 text-sky-800 border-sky-300"],
  checked_in: ["Checked in", "bg-violet-100 text-violet-800 border-violet-300"],
  completed: ["Completed", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  declined: ["Patient declined", "bg-rose-100 text-rose-800 border-rose-300"],
  clinically_not_fit: ["Clinically not fit", "bg-orange-100 text-orange-800 border-orange-300"],
  cancelled: ["Cancelled", "bg-slate-100 text-slate-600 border-slate-300"],
  no_show: ["No show", "bg-amber-100 text-amber-800 border-amber-300"],
};

const end = (s, m) => { if (!s) return ""; const t = Number(s.slice(0, 2)) * 60 + Number(s.slice(3)) + m; return `${String(Math.floor(t / 60) % 24).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`; };

export default function ApptCard({ a, facilityName, reload }) {
  const [pick, setPick] = useState(null);
  const [note, setNote] = useState("");
  const [lbl, cls] = APPT_STATUS[a.status] || APPT_STATUS.scheduled;
  const set = async (status, n) => {
    try { await api.patch(`/appointments/${a.id}`, { status, note: n }); toast.success(`Visit marked ${APPT_STATUS[status][0].toLowerCase()}`); setPick(null); setNote(""); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className={`rounded-lg border-l-4 border p-2.5 text-sm ${cls}`} data-testid={`appt-card-${a.id}`}>
      <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0">
          <p className="font-semibold truncate" data-testid={`appt-patient-name-${a.id}`}>{a.patient_name}</p>
          <p className="text-xs opacity-80">{a.start ? `${a.start}-${end(a.start, a.duration_min)}` : "Time not set"} - {a.duration_min} min{a.visit_type ? ` - ${a.visit_type}` : ""}</p>
          <p className="text-xs opacity-80 truncate">{facilityName || "No facility"}</p>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild><Button size="sm" variant="outline" className="h-7 px-2 bg-white/70 text-xs" data-testid={`appt-status-menu-${a.id}`}>{lbl}</Button></DropdownMenuTrigger>
          <DropdownMenuContent align="end">{Object.entries(APPT_STATUS).filter(([k]) => k !== a.status).map(([k, [l]]) => (
            <DropdownMenuItem key={k} onClick={() => (["declined", "clinically_not_fit"].includes(k) ? setPick(k) : set(k))} data-testid={`appt-set-${k}-${a.id}`}>{l}</DropdownMenuItem>))}</DropdownMenuContent>
        </DropdownMenu>
      </div>
      {a.status_note && <p className="text-xs mt-1 italic">"{a.status_note}" - {a.status_by}</p>}
      {pick && (
        <div className="mt-2 space-y-1">
          <Textarea className="bg-white text-slate-800" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Reason (required)" data-testid={`appt-note-${a.id}`} />
          <div className="flex gap-1"><Button size="sm" className="h-7" disabled={!note.trim()} onClick={() => set(pick, note)} data-testid={`appt-note-save-${a.id}`}>Save</Button>
            <Button size="sm" variant="outline" className="h-7 bg-white" onClick={() => setPick(null)}>Cancel</Button></div>
        </div>
      )}
    </div>
  );
}
